import { TrustArcLoader } from '@/components/TrustArc/TrustArcLoader'

export function Footer() {
  return (
    <>
      <TrustArcLoader />
      <footer className="w-full bg-[#434343] px-6 py-3 text-white shadow-md">
        <div
          id="consent_blackbar_unique"
          className="flex min-h-6 items-center justify-start"
        >
          <div id="consent_blackbar" />
          <div id="teconsent" className="inline-block" />
        </div>
      </footer>
    </>
  )
}
